function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M100 180C144.183 180 180 144.183 180 100C180 55.8172 144.183 20 100 20C55.8172 20 20 55.8172 20 100C20 144.183 55.8172 180 100 180Z",
  fill: "#FFB6B6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M100 180C144.183 180 180 144.183 180 100C180 55.8172 144.183 20 100 20C55.8172 20 20 55.8172 20 100C20 144.183 55.8172 180 100 180Z",
  fill: "url(#paint0_linear_263_1685)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M73.8664 94.7733L126.346 93.6L134.24 27.68C123.893 22.7733 112.266 20 99.9998 20C87.7331 20 76.1064 22.7733 65.7598 27.68L73.8664 94.7733Z",
  fill: "url(#paint1_linear_263_1685)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M154.507 98.9333H45.4933C42.6133 98.9333 40.2666 96.5867 40.2666 93.7067V59.36C40.2666 56.48 42.6133 54.1333 45.4933 54.1333H154.507C157.387 54.1333 159.733 56.48 159.733 59.36V93.7067C159.733 96.5867 157.387 98.9333 154.507 98.9333Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M154.507 98.9333H45.4933C42.6133 98.9333 40.2666 96.5867 40.2666 93.7067V59.36C40.2666 56.48 42.6133 54.1333 45.4933 54.1333H154.507C157.387 54.1333 159.733 56.48 159.733 59.36V93.7067C159.733 96.5867 157.387 98.9333 154.507 98.9333Z",
  fill: "url(#paint2_linear_263_1685)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M153.333 81.8667H46.6665V85.0667H153.333V81.8667Z",
  fill: "#FFD7D7"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M84.0001 60.5333H63.7334V62.6667H84.0001V60.5333Z",
  fill: "#FF5151"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M84.0001 64.8H63.7334V66.9333H84.0001V64.8Z",
  fill: "#FF5151"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M84.0001 69.0667H63.7334V71.2H84.0001V69.0667Z",
  fill: "#FFD7D7"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M153.333 76.5333H46.6665V79.7333H153.333V76.5333Z",
  fill: "#FFD7D7"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M61.5998 91.4667H46.6665V93.6H61.5998V91.4667Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M70.1334 91.4667H63.7334V93.6H70.1334V91.4667Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M109.173 50.9333C110.587 50.9333 111.733 49.7871 111.733 48.3733C111.733 46.9594 110.587 45.8133 109.173 45.8133C107.759 45.8133 106.613 46.9594 106.613 48.3733C106.613 49.7871 107.759 50.9333 109.173 50.9333Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M79.2001 40.3733C80.0838 40.3733 80.8001 39.657 80.8001 38.7733C80.8001 37.8897 80.0838 37.1733 79.2001 37.1733C78.3164 37.1733 77.6001 37.8897 77.6001 38.7733C77.6001 39.657 78.3164 40.3733 79.2001 40.3733Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M121.653 31.2C122.537 31.2 123.253 30.4837 123.253 29.6C123.253 28.7163 122.537 28 121.653 28C120.77 28 120.053 28.7163 120.053 29.6C120.053 30.4837 120.77 31.2 121.653 31.2Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M148 134.987H146.08V133.067C146.08 132.32 145.44 131.68 144.693 131.68C143.947 131.68 143.307 132.32 143.307 133.067V134.987H141.387C140.64 134.987 140 135.627 140 136.373C140 137.12 140.64 137.76 141.387 137.76H143.307V139.68C143.307 140.427 143.947 141.067 144.693 141.067C145.44 141.067 146.08 140.427 146.08 139.68V137.76H148C148.747 137.76 149.387 137.12 149.387 136.373C149.387 135.627 148.853 134.987 148 134.987Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M58.9332 123.573H57.6532V122.293C57.6532 121.76 57.2265 121.333 56.6932 121.333C56.1598 121.333 55.7332 121.76 55.7332 122.293V123.573H54.4532C53.9198 123.573 53.4932 124 53.4932 124.533C53.4932 125.067 53.9198 125.493 54.4532 125.493H55.7332V126.773C55.7332 127.307 56.1598 127.733 56.6932 127.733C57.2265 127.733 57.6532 127.307 57.6532 126.773V125.493H58.9332C59.4665 125.493 59.8932 125.067 59.8932 124.533C59.8932 124 59.4665 123.573 58.9332 123.573Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M115.36 160.8H84.7468C82.6135 160.8 80.9068 159.2 80.5868 157.173L74.2935 105.013H125.6L119.307 157.173C119.2 159.2 117.493 160.8 115.36 160.8Z",
  fill: "url(#paint3_linear_263_1685)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M88.6935 151.84C87.5202 151.84 86.5602 150.987 86.4535 149.813L83.4668 115.147C83.3602 113.867 84.4268 112.693 85.7068 112.693C86.8802 112.693 87.8402 113.547 87.9468 114.72L90.9335 149.387C91.0402 150.773 89.9735 151.84 88.6935 151.84Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M111.413 151.84C110.133 151.84 109.067 150.773 109.173 149.387L112.16 114.72C112.267 113.547 113.227 112.693 114.4 112.693C115.68 112.693 116.747 113.76 116.64 115.147L113.653 149.813C113.547 150.987 112.587 151.84 111.413 151.84Z",
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M100 151.84C98.7203 151.84 97.7603 150.88 97.7603 149.6V115.04C97.7603 113.76 98.7203 112.8 100 112.8C101.28 112.8 102.24 113.76 102.24 115.04V149.6C102.24 150.88 101.28 151.84 100 151.84Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M125.28 108.64H74.8267V109.173H125.173L125.28 108.64Z",
  fill: "#FFB6B6"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M119.627 156H80.48L80.5866 156.533H119.52L119.627 156Z",
  fill: "#FFB6B6"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M129.12 94.0266L113.76 89.3333C113.76 89.3333 113.76 89.3333 113.653 89.3333L95.2001 83.68L79.6268 78.88C77.9201 78.3466 76.2135 79.3066 75.6801 81.0133L74.2935 85.4933L129.76 102.56L131.147 98.08C131.68 96.3733 130.827 94.56 129.12 94.0266Z",
  fill: "url(#paint4_linear_263_1685)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M100.64 84.64C101.6 82.9333 103.627 82.08 105.547 82.6133C107.467 83.2533 108.64 85.0667 108.533 87.0933L111.84 88.0533C112.48 84.32 110.347 80.5867 106.613 79.4133C102.88 78.24 98.9333 80.16 97.4399 83.5733L100.64 84.64Z",
  fill: "url(#paint5_linear_263_1685)"
});

var _ref27 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_263_1685)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.8533 61.5341V59.4H52.1416V61.5345H52.4974L52.8533 61.5341Z",
  fill: "url(#paint6_linear_263_1685)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.4062 64.5861L58.5 64.1676L58.3619 63.4697L56.2681 63.8882L56.4062 64.5861Z",
  fill: "url(#paint7_linear_263_1685)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.5999 60.2482L55.0908 61.7572L55.594 62.2604L57.1031 60.7515L56.5999 60.2482Z",
  fill: "url(#paint8_linear_263_1685)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.8325 68.1239H56.1376L55.1364 63.5369C55.0573 63.171 54.8542 62.8435 54.562 62.6094C54.2711 62.3743 53.9084 62.2458 53.5338 62.2458H51.3535C50.9743 62.2467 50.6066 62.3789 50.3135 62.6194C50.0203 62.86 49.8186 63.1943 49.7431 63.5662L48.8325 68.1239Z",
  fill: "url(#paint9_linear_263_1685)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.295 68.8383H48.6899V68.8415C48.5184 68.9014 48.3601 68.9947 48.2298 69.125C48.0015 69.3533 47.8735 69.6629 47.8726 69.9858V71.4947H57.1224V69.9858C57.1219 69.6629 56.993 69.3533 56.7647 69.125C56.6316 68.9919 56.4697 68.8977 56.295 68.8383Z",
  fill: "url(#paint10_linear_263_1685)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.6383 63.4655L46.4995 64.1635L48.5948 64.5803L48.7337 63.8823L46.6383 63.4655Z",
  fill: "url(#paint11_linear_263_1685)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.394 60.247L47.8901 60.7503L49.3983 62.2601L49.9021 61.7569L48.394 60.247Z",
  fill: "url(#paint12_linear_263_1685)"
}));

var _ref28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_263_1685",
  x1: 100.023,
  y1: 180,
  x2: 100.023,
  y2: 20,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2899,
  stopColor: "#FFD0D0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.946,
  stopColor: "#FF5B5B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5151"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_263_1685",
  x1: 100.028,
  y1: 94.7594,
  x2: 100.028,
  y2: 20,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.000517669,
  stopColor: "#F8F9FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F8F9FC",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_263_1685",
  x1: 100.029,
  y1: 54.1333,
  x2: 100.029,
  y2: 98.9333,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.000111817,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2589,
  stopColor: "#FFFCFC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4823,
  stopColor: "#FFF1F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6927,
  stopColor: "#FFDFDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8938,
  stopColor: "#FFC6C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB6B6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_263_1685",
  x1: 100.042,
  y1: 104.975,
  x2: 100.042,
  y2: 160.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE5050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C6000F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_263_1685",
  x1: 78.4052,
  y1: 98.4651,
  x2: 127.293,
  y2: 83.3967,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE5050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C6000F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_263_1685",
  x1: 98.2142,
  y1: 86.4996,
  x2: 110.964,
  y2: 82.5697,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE5050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C6000F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_263_1685",
  x1: 52.1462,
  y1: 60.4675,
  x2: 52.8487,
  y2: 60.4675,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE5050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED1828"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_263_1685",
  x1: 56.2809,
  y1: 64.0281,
  x2: 58.4854,
  y2: 64.0281,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE5050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED1828"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_263_1685",
  x1: 55.1026,
  y1: 61.2539,
  x2: 57.0903,
  y2: 61.2539,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE5050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED1828"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_263_1685",
  x1: 47.9264,
  y1: 65.1848,
  x2: 57.0624,
  y2: 65.1848,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE5050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED1828"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_263_1685",
  x1: 47.9265,
  y1: 70.1665,
  x2: 57.0625,
  y2: 70.1665,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE5050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED1828"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_263_1685",
  x1: 46.5131,
  y1: 64.0232,
  x2: 48.719,
  y2: 64.0232,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE5050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED1828"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_263_1685",
  x1: 47.9017,
  y1: 61.2536,
  x2: 49.889,
  y2: 61.2536,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE5050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED1828"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_263_1685"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12.0947,
  fill: "white",
  transform: "translate(46.5 59.4)"
})));

var SvgDeleteAlert = function SvgDeleteAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-alert.e027a3a6.svg";
export { ForwardRef as ReactComponent };